import React, { useState } from "react";
import { FullscreenOutlined } from "@ant-design/icons";
import { Button, Modal, Tooltip } from "antd";
import { DistributionGraph } from "./DistributionGraph";
import { AverageGraph } from "./AverageGraph";

const Graphs = ({
  BIN_END,
  isImperial,
  currentOrg,
  currentSite,
  currentCrop,
  currentGreenhouse,
  currentPlot,
  currentDate,
  graphData,
  dateList,
  siteMetadata,
  minSize,
  maxSize,
  showPercentage,
  setShowPercentage,
  filteredGraphData,
  setFilteredGraphData,
  averageData,
  setAverageData,
}) => {
  const [visibility, setVisibility] = useState({});
  const [fullscreenTarget, setFullscreenTarget] = useState(null);
  const fullscreenInset = "clamp(8px, 2.2vw, 24px)";
  const fullscreenWrapperPadding = "clamp(4px, 1.1vw, 12px)";

  function hasGraphData(graphData) {
    // Iterate over the dates in the graphData object
    for (const date in graphData) {
      // Check if the average_length_cm is not null for any date
      if (graphData[date].average_length_cm !== null) {
        return true; // Return true if we find any non-null value
      }
    }
    // Return false if all average_length_cm are null
    return false;
  }
  return (
    <>
      {hasGraphData(graphData) && (
        <div className="flex w-full flex-row gap-4 xl:flex-col">
          <div className="graph-section relative w-full rounded-md px-5 py-2.5 xl:px-4 lg:px-3 md:px-2 sm:px-1.5 shadow-md transition-shadow duration-300 hover:shadow-2xl">
            <Tooltip title="Open fullscreen">
              <Button
                type="text"
                aria-label="Open distribution graph in fullscreen"
                icon={<FullscreenOutlined />}
                onClick={() => setFullscreenTarget("distribution")}
                className="!absolute right-2 top-2 z-20 !text-primaryBlue"
              />
            </Tooltip>
            <DistributionGraph
              BIN_END={BIN_END}
              isImperial={isImperial}
              graphData={graphData}
              dateList={dateList}
              minSize={minSize}
              maxSize={maxSize}
              visibility={visibility}
              setVisibility={setVisibility}
              showPercentage={showPercentage}
              setShowPercentage={setShowPercentage}
              filteredGraphData={filteredGraphData}
              setFilteredGraphData={setFilteredGraphData}
              setAverageData={setAverageData}
            ></DistributionGraph>
          </div>
          <div className="graph-section relative w-full rounded-md px-5 py-2.5 xl:px-4 lg:px-3 md:px-2 sm:px-1.5 shadow-md transition-shadow duration-300 hover:shadow-2xl">
            <Tooltip title="Open fullscreen">
              <Button
                type="text"
                aria-label="Open average graph in fullscreen"
                icon={<FullscreenOutlined />}
                onClick={() => setFullscreenTarget("average")}
                className="!absolute right-2 top-2 z-20 !text-primaryBlue"
              />
            </Tooltip>
            <AverageGraph
              averageData={averageData}
              visibility={visibility}
              setVisibility={setVisibility}
              isImperial={isImperial}
              currentOrg={currentOrg}
              currentSite={currentSite}
              currentCrop={currentCrop}
              currentGreenhouse={currentGreenhouse}
              currentPlot={currentPlot}
              currentDate={currentDate}
              siteMetadata={siteMetadata}
            ></AverageGraph>
          </div>
        </div>
      )}
      <Modal
        open={Boolean(fullscreenTarget)}
        onCancel={() => setFullscreenTarget(null)}
        footer={null}
        title={null}
        width={`calc(100% - ${fullscreenInset})`}
        centered={true}
        destroyOnHidden={true}
        styles={{
          wrapper: {
            overflow: "hidden",
            padding: fullscreenWrapperPadding,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          body: {
            padding: 0,
            height: `calc(100dvh - ${fullscreenInset})`,
            overflow: "hidden",
          },
          content: {
            padding: 0,
            height: `calc(100dvh - ${fullscreenInset})`,
            overflow: "hidden",
          },
        }}
        style={{
          paddingBottom: 0,
          maxWidth: "none",
          margin: "0 auto",
        }}
        className="!max-w-none"
      >
        <div className="h-full min-h-0 overflow-hidden p-2 lg:p-1.5 md:p-1 sm:p-0.5">
          <div className="h-full min-h-0 overflow-hidden">
            {fullscreenTarget === "distribution" ? (
              <DistributionGraph
                BIN_END={BIN_END}
                isImperial={isImperial}
                graphData={graphData}
                dateList={dateList}
                minSize={minSize}
                maxSize={maxSize}
                visibility={visibility}
                setVisibility={setVisibility}
                showPercentage={showPercentage}
                setShowPercentage={setShowPercentage}
                filteredGraphData={filteredGraphData}
                setFilteredGraphData={setFilteredGraphData}
                setAverageData={setAverageData}
                isFullscreen={true}
              />
            ) : (
              <AverageGraph
                averageData={averageData}
                visibility={visibility}
                setVisibility={setVisibility}
                isImperial={isImperial}
                currentOrg={currentOrg}
                currentSite={currentSite}
                currentCrop={currentCrop}
                currentGreenhouse={currentGreenhouse}
                currentPlot={currentPlot}
                currentDate={currentDate}
                siteMetadata={siteMetadata}
                isFullscreen={true}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export { Graphs };
